export default __webpack_public_path__ + "static/media/coverhome.8c475927.png";